import React from 'react';
import { Button, Form, InputGroup, Modal } from 'react-bootstrap';

// project-imports
import { copy_to_clipboard } from '../../utils';
import { GoogleAnalyticsEnum, triggerFunction } from '../../utils/google-analytics';

const UPI_ID = process.env.REACT_APP_LONGSWITCH_ACADEMY_UPI_ID;
const YOUTUBE_CHANNEL_URL = process.env.REACT_APP_YOUTUBE_CHANNEL_URL;

export const SupportUsForm = ({ show, onCloseModal, title = "Form" }) => {
    return (
        <div>
            <Modal
                className="rounded-lg"
                show={show}
                onHide={onCloseModal}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                size="xl"
            >
                <Modal.Header closeButton className="px-5 pb-0">
                    <Modal.Title as="h4" className="mb-0">{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center px-4 pb-4">
                    <div className="container text-center">
                        <div className="row align-items-stretch justify-content-center g-0">

                            {/* Left Column */}
                            <div className="col-12 col-lg-6 py-4 rounded-start">
                                <p className="mb-0 text-start mx-3">
                                    At <a href={YOUTUBE_CHANNEL_URL} target="_blank" rel="noreferrer" className="text-orange"><strong>Longswitch Academy</strong></a>, we believe quality education should be <strong>free and accessible to everyone</strong>.
                                    We started with <strong>Salesforce</strong> and are now expanding into <strong>web and full-stack development</strong> to help learners build real-world skills.
                                    <br /><br />We create <strong>practical, beginner-friendly content</strong> so anyone with an internet connection can <strong>learn and grow, regardless</strong> of their background.
                                    <br /><br />If we’ve helped you in any way, please consider <strong>supporting us with a small donation</strong>. Every contribution helps us keep education free and reach more learners.
                                    <br /><br /><strong className="text-purple">Support education. Support transformation</strong>.
                                </p>
                            </div>

                            {/* Divider verticle */}
                            {/* <div className="col-lg-1 d-none d-lg-flex justify-content-center">
                                <div className="vr"></div>
                            </div> */}

                            <div className="col-12 col-lg-6 py-4 bg-light rounded-end">
                                <h5 className="mb-2">Scan this QR Code</h5>
                                {/* <p className="mb-2">Use this QR to support us</p> */}
                                <img
                                    width="158"
                                    height="158"
                                    src={`${process.env.PUBLIC_URL + '/images/gallery/Longswitch_Academy_qr_code.png'}`}
                                    alt="QR Code"
                                    className="mb-2"
                                />
                                <p className="mb-2">Or use this UPI ID manually</p>

                                <div className="d-flex justify-content-center p-2">
                                    <InputGroup className="upi-input-group w-75">
                                        <Form.Control
                                            type="text"
                                            disabled
                                            value={UPI_ID}
                                            placeholder="UPI ID"
                                            aria-label="UPI ID"
                                            className="bg-white fs-3 border-1 border-secondary shadow-none"
                                        />
                                        <Button
                                            variant="outline-secondary"
                                            className="fs-3 copy-btn border-1"
                                            onClick={() => {
                                                copy_to_clipboard(UPI_ID);
                                                triggerFunction(window.location.href + GoogleAnalyticsEnum.BUTTON, GoogleAnalyticsEnum.LSA_SUPPORT_FORM_UPI_COPIED);
                                            }}
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-copy" viewBox="0 0 16 16">
                                                <path fillRule="evenodd" d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z" />
                                            </svg>
                                        </Button>
                                    </InputGroup>
                                </div>

                                <Button
                                    className="edu-btn thanks-btn btn-small w-75 my-2"
                                    onClick={() => {
                                        onCloseModal();
                                        triggerFunction(window.location.href + GoogleAnalyticsEnum.BUTTON, GoogleAnalyticsEnum.LSA_SUPPORT_FORM_CLOSE);
                                    }}
                                >
                                    Thank You !
                                </Button>
                            </div>
                        </div>
                    </div>


                </Modal.Body>
            </Modal>
        </div>
    )
}
